import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "gatsby-material-ui-components";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: 16,
    "&:hover": {
      backgroundColor: theme.palette.background.medium,
    },
  },
  btnSelected: {
    backgroundColor: theme.palette.background.medium,
  },
  portTitle: {
    fontWeight: "bold",
    fontSize: "1.2em",
  },
  portParag: {
    margin: `${theme.spacing(0.5)}px 0`,
    textAlign: "left",
  },
}));

const PortfolioItem = ({
  title,
  titleColor,
  content,
  changeIndex,
  index,
  idx,
}) => {
  const classes = useStyles();
  return (
    <Grid item>
      <Button
        fullWidth
        className={clsx(classes.root, {
          [classes.btnSelected]: idx === index,
        })}
        onClick={() => changeIndex(idx)}
      >
        <Grid container direction="column" alignItems="flex-start">
          <Grid item>
            <Typography
              variant="h6"
              className={classes.portTitle}
              style={{ color: titleColor }}
            >
              {title}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              variant="body1"
              color="textPrimary"
              className={classes.portParag}
            >
              {content}
            </Typography>
          </Grid>
        </Grid>
      </Button>
    </Grid>
  );
};

export default PortfolioItem;
